<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '50vw'}">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<div class="card">
  <h2 style="text-align: center;">Solicitud de Canje</h2>

  <p-toolbar styleClass="mb-4 gap-2">
    <ng-template pTemplate="left">
      <form [formGroup]="canjeForm" (ngSubmit)="onSubmit()" id="medico-canje-add-frm">
        <div class="formgrid grid">
          <!-- fecha -->
          <div class="field col-12 md:col-12">

            <label for="fecha">Fecha *:</label>
            <p-calendar id="fecha" formControlName="fechaInicio" [maxDate]="fechaMaxCanjeHoy" dateFormat="dd/mm/yy"
              placeholder="Ingrese la fecha"
              inputStyleClass="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              [ngClass]="{'ng-invalid ng-dirty': f['fechaInicio'].touched && f['fechaInicio'].errors}"></p-calendar>
            <small class="p-error" *ngIf="f['fechaInicio'].touched && f['fechaInicio'].errors?.['required']">
              La fecha es requerida
            </small>
          </div>
          <!-- Descripcion  -->
          <div class="field col-12 md:col-12">
            <label for="descripcion">Descripcion</label>
            <input id="descripcion" type="text" pInputText [maxlength]="120" formControlName="descripcion"
              class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              [ngClass]="{'ng-invalid ng-dirty': f['descripcion'].touched && f['descripcion'].errors}">
            <small class="p-error" *ngIf="f['descripcion'].touched && f['descripcion'].errors?.['required']">
              El concepto es requerido
            </small>
          </div>
          <div class="field col-12 md:col-12">
            <button form="medico-canje-add-frm" type="submit" label="Solicitar" icon="pi pi-save" class="mr-2" pButton
              [disabled]="canjeForm.invalid">
            </button>
          </div>
        </div>
      </form>
    </ng-template>
  </p-toolbar>

  <p-table [value]="productosCanjear" [(selection)]="selectedProductos" dataKey="id" [paginator]="true"
    [showCurrentPageReport]="true" [rows]="10"
    currentPageReportTemplate="Mostrar {first} al {last} de {totalRecords} registros" class="mt-4">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 4rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th>Codigo</th>
        <th>Producto</th>
        <th>Caso Clinico</th>
        <th class="text-right">Puntos</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-producto>
      <tr>
        <td>
          <p-tableCheckbox [value]="producto"></p-tableCheckbox>
        </td>
        <td>{{ producto.codigo }}</td>
        <td>{{ producto.nomProducto }}</td>
        <td>{{ producto.casoclinico.serie }}</td>
        <td class="text-right">{{ producto.m_puntos }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <th colspan="3"></th>
        <th class="text-left">No. Productos Seleccionado</th>
        <th class="text-right" style="padding-right: 10px;"> {{selectedProductos.length}}</th>
      </tr>
      <tr>
        <th colspan="3"></th>
        <th class="text-left">Solicitud a canjear</th>
        <th class="text-right" style="padding-right: 10px;">{{cantidadSolicitar}} </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center p-4">
          <div class="flex flex-column align-items-center">
            <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
            <span class="text-600 mt-2">No se encontraron casos clinicos</span>
          </div>
        </td>
      </tr>
    </ng-template>

  </p-table>

</div>